module.exports = __webpack_public_path__ + "img/dy_cont_bg.954ae58f.png";